const container = {
  paddingRight: '15px',
  paddingLeft: '15px',
  marginRight: 'auto',
  marginLeft: 'auto',
}
const appStyle = (theme) => ({
  wrapper: {
    position: 'relative',
    top: '0',
    minHeight: '100vh',
    backgroundImage: `url(${process.env.PUBLIC_URL + '/images/bg-5.webp'})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  content: {
    marginTop: '71px',
    padding: '15px',
    minHeight: '100%',
  },
  container,
  map: {
    marginTop: '70px',
  },
  maximMainPanel: {
    width: '100%',
    height: '100%',
    marginTop: '71px',
    '& $content': {
      padding: 0,
      marginTop: 0,
      display: 'flex',
      height: '100%',
      width: '100%',
      flexDirection: 'column',
      '& $container': {
        padding: 0,
        margin: 0,
        height: '100%',
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
})

export default appStyle
